import { mapState, mapActions } from "vuex";
import questionEdit from "@/pages/htmlSplit/components/questionEdit";
import editorHtml from "@/pages/htmlSplit/components/editorHtml";
import setTagDialog from "@/pages/htmlSplit/components/setTagDialog";
import editRuleDialog from "@/pages/htmlSplit/components/editRuleDialog";

import { deepClone, isEmpty, newGuid } from '@/utils/tools';
import { Steps, Step } from "element-ui";

const splitMixins = {
  components: {
    questionEdit,
    editorHtml,
    setTagDialog,
    editRuleDialog,
    [Steps.name]: Steps,
    [Step.name]: Step,
  },
  computed: {
    ...mapState({
      // 不要m选n
      basicQuestionType(state) {
        if (!state.basicDataV3.basicQuestionType) {
          return []
        }
        return state.basicDataV3.basicQuestionType.filter(item => {
          return !isEmpty(item.structureTypeId) && item.structureTypeId !== 6
        })
      },
    }),
    doneNum() {
      return this.questionList.filter((item) => [1, 4].includes(item.status))
        .length;
    },
    undoNum() {
      return this.questionList.filter((item) => [0, 3].includes(item.status))
        .length;
    }
  },
  data() {
    return {
      editablePaper: false,
      tagVisible: false,
      ruleVisible: false,
      tagInfo: {},
      htmlStr: "",
      originHtmlContent: "",
      scoreVisible: false,
      questionList: [],
      curQuestionIndex: -1,
      curQuestion: {},
      // editorId: "",
      splitApp: null,
      // curDivideObj: {},
      curRange: null, // 当前手动划题区域
      isReSplit: false,
      submitLoading: false,
      splitLoading: false,
      tempStr: '',
      lostArr: []
    }
  },
  // created() {
    // tinymce = window.tinymce;
    // this.editorId = newGuid();
    // this.splitApp = new htmlSplit()
  // },
  methods: {
    ...mapActions('basicDataV3', ['getQuestionTypeList', 'getBasicKnowledgePointList', 'getDifficultList']),
    showRule() {
      this.ruleVisible = true
    },
    // 新增小题的时候更新题号
    refreshQuestionNum(curQuestion, index) {
      // 先判断是否有新增的题号
      // let curQuestion = this.questionList[index]
      if (![7, 8].includes(+curQuestion.structId) || !curQuestion.children || curQuestion.children.length === 0) {
        return
      }
      let isAdd = !(curQuestion.children[curQuestion.children.length - 1]
          && curQuestion.children[curQuestion.children.length - 1].orderNumber)
      if (isAdd) {
        let start = curQuestion.children[0].orderNumber
        // 当前+1, 重复
        curQuestion.children.forEach(item => {
          if(!item.orderNumber) {
            item.orderNumber = start
            item.questionNumber = start
          }
          start++
        })
        // 顺延+1, 不重复，todo
      }
    },
    // 计算左侧题号显示
    setLeftQuestionNum() {
      this.$nextTick(() => {
        // 先清掉左侧之前的题号
        setTimeout(() => {
          $('body').find(".question-number").remove();
          // 在重新算
          let els = document.getElementsByClassName('qArea')
          let existNums = []
          this.questionList.forEach((item, index) => {
            let text = ''
            let orders = []
            let questions = []
            let structId = item.structId
            if (structId) {
              structId = +structId
            }
            if (item.children && item.children.length > 0 && [7, 8].includes(structId)) {
              orders =  item.children.map(citem => {
                return citem.orderNumber || ''
              })
              questions =  item.children.map(citem => {
                return citem.questionNumber
              })
              existNums = existNums.concat(orders)
              text = '（第' + orders.join(',') + '题）'
              if (this.splitPage === 'jf') {
                text = '题号：（第' + orders.join(',') + '题）教辅题号：' + questions.join(',')
              }
            }
            else {
              existNums.push(item.orderNumber)
              text = '（第' + item.orderNumber + '题）'
              if (this.splitPage === 'jf') {
                text = '题号：（第' + item.orderNumber + '题）教辅题号：' + item.questionNumber
              }
            }
            if (els[index]) {
              const span = document.createElement('span');
              span.className = "question-number"
              span.innerText = text
              els[index].prepend(span)
              this.setTianKongNum(els[index])
            }
          })
          this.lostArr = this.findMissingNumbersEfficient(existNums);
        }, 200);
      })
    },
    // 填空补充
    setTianKongNum(el) {
      let paragraphs = Array.from(el.childNodes);
      let struct = el.getAttribute('data-struct') || ''
      if (struct !== '4' && struct !== '8') {
        return
      }
      let curTag = ''
      let index = 1
      let qNum = 0
      // 撸掉p里的span和a
      paragraphs.forEach(p => {
        if (p.tagName === 'P') {
          let tag = p.getAttribute('data-filed')
          curTag = tag ? tag :  curTag
          if (struct === '4' && ['题干'].includes(curTag)) {
            // 看看要不要一个个子标签读过去 todo
            let stem = p.innerHTML
            if(/<[^>]+?bdo.*?code[^>]+?>/.test(stem)) {
              return
            }
            // 避免替换错空格
            let origStem = stem
            // &nbsp;换空格
            stem = stem.replace(/&nbsp;/g, ' ');
            // 将underline转换成与空格等数量的_
            stem = stem.replace(/<span[^>]*?text-decoration:\s*underline[^>]*?>([\s_]+)<\/[^>]*?>/g, ($1, $2) => {
              return new Array($2.length).fill('_').join('')
            });
            // 有underline下横线且下横线至少2个不同的空格
            // if (/<span[^>]*?text-decoration:\s*underline[^>]*?>\s{2,}<\/[^>]*?>/.test(stem)) {
            //   let temp = stem.replace(/(<span[^>]*?text-decoration:\s*underline[^>]*?>\s{2,}<\/[^>]*?>)/g, ($1) => {
            //     console.log($1);
            //     let code = btoa(encodeURIComponent($1))
            //     return '<bdo style="text-decoration: underline" code="' + code + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第' + (index++) + '空&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</bdo>'
            //   })
            //   stem = temp
            // }
            // 有_下横线且下横线至少3个
            if (/_{3,}/.test(stem)) {
              let temp = stem.replace(/(_{3,})/g, ($1, $2) => {
                let code = btoa(encodeURIComponent($1))
                return '<bdo style="text-decoration: underline" code="' + code + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第' + (index++) + '空&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</bdo>'
              })
              stem = temp
            }
            else {
              stem = origStem
            }
            p.innerHTML = stem
          }

          if (struct === '8' && ['小题题干'].includes(curTag)) {
            let cstruct = p.getAttribute('data-struct') || ''
            if (cstruct !== '4') {
              return
            }
            if (tag === '小题题干') {
              index = 1
            }
            // 看看要不要一个个子标签读过去 todo
            let stem = p.innerHTML
            if(/<[^>]+?bdo.*?code[^>]+?>/.test(stem)) {
              return
            }
            // 避免替换错空格
            let origStem = stem
            // &nbsp;换空格
            stem = stem.replace(/&nbsp;/g, ' ');
            // 将underline转换成与空格等数量的_
            stem = stem.replace(/<span[^>]*?text-decoration:\s*underline[^>]*?>([\s_]+)<\/[^>]*?>/g, ($1, $2) => {
              return new Array($2.length).fill('_').join('')
            });
            // 有underline下横线且下横线至少2个不同的空格
            // if (/<span[^>]*?text-decoration:\s*underline[^>]*?>\s{2,}<\/[^>]*?>/.test(stem)) {
            //   let temp = stem.replace(/(<span[^>]*?text-decoration:\s*underline[^>]*?>\s{2,}<\/[^>]*?>)/g, ($1) => {
            //     console.log($1);
            //     let code = btoa(encodeURIComponent($1))
            //     return '<bdo style="text-decoration: underline" code="' + code + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第' + (index++) + '空&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</bdo>'
            //   })
            //   stem = temp
            // }
            // 有_下横线且下横线至少3个
            if (/_{3,}/.test(stem)) {
              let temp = stem.replace(/(_{3,})/g, ($1, $2) => {
                let code = btoa(encodeURIComponent($1))
                return '<bdo style="text-decoration: underline" code="' + code + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第' + (index++) + '空&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</bdo>'
              })
              stem = temp
            }
            else {
              stem = origStem
            }
            p.innerHTML = stem
          }
        }
      })
    },
    // 辅助函数
    // 获取字符串里的字母
    findCapitalLetter(text, obj) {
      if (!text) {
          return ""
      }
      if (!obj) {
          return ""
      }
      let result = '';
      // 使用正则表达式匹配所有的大写英文字母
      let matches = text.match(/[A-Z]/g);
      // 去重
      matches = [...new Set(matches)]
      // 如果存在匹配的结果，则将它们组合成一个新的字符串，否则返回空字符串
      let str = matches ? matches.join('') : '';

      // 遍历字符串中的每一个字符
      for (let i = 0; i < str.length; i++) {
          let char = str[i];
          // 检查当前字符是否是对象的一个键
          if (obj.hasOwnProperty(char)) {
              // 如果是，将它添加到结果字符串
              result += char;
          }
      }
      return result;
    },
    // 获取对错
    findCapitalJudge(text) {
        if (!text) {
            return ""
        }
        // 使用正则表达式匹配所有的大写英文字母
        const matches = text.match(/(对|错|正确|错误|T|F)/);
        // 如果存在匹配的结果，则将它们组合成一个新的字符串，否则返回空字符串
        let str = matches ? matches[0] : '';
        let map = {
            '对': '对',
            '错': '错',
            '正确': '对',
            '错误': '错',
            'T': '对',
            'F': '错'
        }
        return map[str] || '';
    },
    // 获取缺的题号
    findMissingNumbersEfficient(arr) {
      if (arr.length === 0) return [];

      let numSet = new Set(arr);
      let max = Math.max(...arr);
      let missingNumbers = [];

      for (let i = 1; i <= max; i++) {
        if (!numSet.has(i)) {
          missingNumbers.push(i);
        }
      }

      return missingNumbers;
    },
    /**
     * @description: 取出包裹p的div容器标签
     * @param {*} container div容器
     * @param {*} type 输出类型
     * @return {*} str输出处理后的html字符串，node为处理后的dom元素
     */
    div2p(container, type = "str") {
      // 获取所有 div 元素
      let divs = Array.from(container.querySelectorAll("div"));
      if (divs.length === 0 && container.tagName === "DIV") {
        divs = [container];
      }
      // 遍历每个 div 元素
      divs.forEach((div) => {
        // 获取 div 内的所有 p 元素
        const paragraphs = Array.from(div.childNodes);

        // 在 div 前插入所有 p 元素
        paragraphs.forEach((p) => {
          if (p && p.nodeName === "P") {
            p.removeAttribute("data-filed");
            p.innerHTML = p.innerHTML.replace(/<mark>/g, '').replace(/<\/mark>/g, '')
            p.innerHTML = p.innerHTML.replace(/<bdo[^>]*?code="(.+?)"[^>]*?>.*?<\/bdo>/g, ($1, $2) => {
              return decodeURIComponent(atob($2))
            })
          }
          div.parentNode.insertBefore(p, div);
        });

        // 移除原来的 div 元素
        div.parentNode.removeChild(div);
      });
      return type === "str" ? container.innerHTML : container.children;
    },
    /**
     * @description: 从html字符串里获取纯文本
     * @param {*} htmlString
     * @return {*} 纯文本
     */
    getTextFromTag(htmlString) {
      let textContent = "";
      if (!htmlString) {
        return "";
      }
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        textContent = doc.documentElement.textContent;
        return textContent;
      } catch (error) {
        return htmlString;
      }
    },
    // 找到当前第几个体块
    getElementIndex(elem) {
      var parent = elem.parentElement;
      let max = 10; // 最大层级树
      while(parent.id != 'splitHtmlEditor' && max !== 0) {
        elem = parent
        parent = parent.parentElement;
        max--
      }
      if (!max) {
        return -1
      }
      var children = parent.children;
      var index = 0;
      for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains('qArea')) {
          index++; // 只增加计数当元素符合类名条件
        }
        if (children[i] === elem) {
          return index;
        }
      }
      return -1; // 如果没有找到，返回-1
    },
    // 拆解相关
    initSplit(subjectName) {
      this.splitApp.setConfig({
        type2StructMap: this.basicQuestionType,
        subjectName: subjectName
      })
    },
    /**
     * @description: 还原拆解
     * @return {*}
     */
    undoSplit() {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.originHtmlContent, 'text/html');
      this.htmlStr = this.div2p(doc.body, "str");
      this.questionList = []
      this.curQuestionIndex = -1;
      this.curQuestion = {};
    },
    /**
     * @description: 清除拆解痕迹
     * @return {*}
     */
    doClearSplit() {
      this.$confirm('此操作将清除全部拆解痕迹, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearSplit()
      }).catch((e) => {
        console.log(e);
      });
    },
    clearSplit() {
       if (this.notEdit) {
        return
      }
      let htmlStr = this.htmlStr;
      const parser = new DOMParser();
      let doc = parser.parseFromString(htmlStr, "text/html");
      $(doc.body).find(".question-number").remove();
      // 题dom列表
      htmlStr = this.div2p(doc.body, "str");
      this.htmlStr = htmlStr
      this.questionList = [];
      this.curQuestionIndex = -1;
      this.curQuestion = {};
    },
    clearSingleSplit(index) {
      if (this.notEdit) {
        return
      }
      if (this.questionList.length === 1) {
        this.curQuestionIndex = -1;
        this.curQuestion = {};
        this.questionList = [];
      } else {
        this.questionList.splice(index, 1);
        if (index === 0) {
          this.curQuestionIndex = -1
          setTimeout(() => {
            this.curQuestionIndex = 0;
          }, 200);
        }
        else {
          this.curQuestionIndex = 0;
        }
        this.curQuestion = this.questionList[0];
      }
      const div = document.getElementsByClassName("qArea")[index];
      this.div2p(div, "node");
      this.htmlStr = document.getElementById("splitHtmlEditor").innerHTML;
      this.setLeftQuestionNum()
    },
    // 拆分主函数
    doSplitConform() {
      if (this.questionList.length === 0) {
        this.doSplit('click')
        return;
      }
      this.$confirm('此操作将清除全部拆解痕迹后重新识别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doSplit('click')
      }).catch((e) => {
        console.log(e);
      });
    },
    async doSplit(type = 'init') {
      if (this.splitLoading) {
        return;
      }
      this.splitLoading = true
      if (type === 'click') {
        this.isReSplit = true
      }
      this.clearSplit();
      // console.log(this.htmlStr);
      if (this.splitApp) {
        let splitObj = this.splitApp.setHtmlStr(this.htmlStr).startSplit();
        if (splitObj.outputList.length === 0) {
          this.loading = false
          this.splitLoading = false
          return;
        }
        this.htmlStr = splitObj.outputHtml;
        this.questionList = await this.dealSplitList(splitObj.outputList)
        if (this.curQuestionIndex < 1) {
          this.curQuestionIndex = -1
          setTimeout(() => {
            this.curQuestionIndex = 0;
          }, 200);
        }
        else {
          this.curQuestionIndex = 0;
        }
        this.curQuestion = this.questionList[0];
        this.setLeftQuestionNum()
      } else {
        this.$message.error("识别异常，请稍后手动点击重新识别！");
      }

      this.loading = false
      this.splitLoading = false
    },
    // 手动识别和自动识别都会调这个处理下拆解数据
    // （这个函数外循环 和 教辅拆解有点不一样，主要是分数校验 和 返回）
    // splitPage out是外循环，jf是教辅数字化, sm是新平台上传
    async dealSplitList(outputList, questionTypeId = "", index = 1) {
      console.log('dealSplitList');
      index = +index

      let res = outputList.map((item) => {
        // todo 这里可能会有问题，下拉选择题型的时候，可能会和结构对不上导致字段不对，但是保存题和提交的时候会按照结构对字段做强校验，不会影响提交
        // todo 切换题型要重新按新机构识别
        item.structId = +item.structId
        item.status = 0
        // 解析 item.analysis和answer 字符串，去掉其中的 text-indent的 样式（todo拆解可以加）
        if (item.analysis) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(item.analysis, 'text/html');
          const elementsWithStyle = doc.querySelectorAll('[style]');
          elementsWithStyle.forEach(element => {
            let style = element.getAttribute('style');
            // 移除 text-indent 样式
            style = style.replace(/text-indent\s*:\s*[^;]+;/gi, '');
            element.setAttribute('style', style.trim());
          });
          item.analysis = doc.body.innerHTML;
        }
        if (item.answer) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(item.answer, 'text/html');
          const elementsWithStyle = doc.querySelectorAll('[style]');
          elementsWithStyle.forEach(element => {
            let style = element.getAttribute('style');
            // 移除 text-indent 样式
            style = style.replace(/text-indent\s*:\s*[^;]+;/gi, '');
            element.setAttribute('style', style.trim());
          });
          item.answer = doc.body.innerHTML;
        }
        // 题型
        if (questionTypeId) {
          item.questionTypeId = questionTypeId
        }
        else {
          item.questionTypeId = item.typeId ? item.typeId : ""
        }
        // 处理id和分数
        if (this.splitPage === 'jf') {
          let allScore = item.splitScore ? +item.splitScore : 0
          if ([7, 8].includes(+item.structId) && !isEmpty(item.children)) {
            // 大题没分数，就当999999，足够分给小题，避免已有的小题分数为0
            let leftScore = allScore === 0 ? 999999 : allScore
            let childLen = item.children.length || 1
            // 找到离整数最近的平均数
            let aviScore = Math.ceil((allScore / childLen))

            item.children = item.children.map(citem => {
              let score = citem.splitScore ? +citem.splitScore : 0
              if (!score) {
                score = leftScore > aviScore ? aviScore : leftScore
                leftScore = leftScore - score
              }
              else {
                score = leftScore > score ? score : leftScore
                leftScore = leftScore - score
              }
              return {
                ...citem,
                score: score,
                id: ""
              }
            })
          }
          item.score = allScore === 0 ? item.children.reduce((total, citem) => {
            return total + citem.score
          }, 0) : allScore
        }
        if (this.splitPage === 'out' || this.splitPage === 'sm') {
          let allScore = item.splitScore ? +item.splitScore : 0
          if ([7, 8].includes(+item.structId) && !isEmpty(item.children)) {
            // 大题没分数，就当999999，足够分给小题，避免已有的小题分数为0
            let leftScore = allScore === 0 ? 999999 : allScore
            let childLen = item.children.length || 1
            // 找到离整数最近的平均数
            let aviScore = Math.ceil((allScore / childLen))

            item.children = item.children.map(citem => {
              let score = citem.splitScore ? +citem.splitScore : 0
              if (!score) {
                score = leftScore > aviScore ? aviScore : leftScore
                leftScore = leftScore - score
              }
              else {
                score = leftScore > score ? score : leftScore
                leftScore = leftScore - score
              }
              return {
                ...citem,
                score: score,
              }
            })
          }
          item.score = allScore === 0 ? item.children.reduce((total, citem) => {
            return total + citem.score
          }, 0) : allScore
        }
        // 强制格式化和校验
        if (+item.structId === 1) {
          item.options = item.options ? item.options : {}
          let answer = this.findCapitalLetter(item.answer, item.options)
          answer = answer.substring(0, 1)
          item.answer = answer
          item.children = []
          if (this.splitPage === 'jf') {
            item.status = item.questionTypeId && item.stem && item.score && !isEmpty(item.options) && item.answer ? 1 : 0
          }
          else if (this.splitPage === 'out' || this.splitPage === 'sm') {
            item.status = item.questionTypeId && item.stem && !isEmpty(item.options) && item.answer ? 1 : 0
          }
        }
        if (+item.structId === 2 || +item.structId === 6) {
          item.options = item.options ? item.options : {}
          item.answer = this.findCapitalLetter(item.answer, item.options)
          item.children = []
          if (this.splitPage === 'jf') {
            item.status = item.questionTypeId && item.stem && item.score && !isEmpty(item.options) && item.answer ? 1 : 0
          }
          else if (this.splitPage === 'out' || this.splitPage === 'sm') {
            item.status = item.questionTypeId && item.stem && !isEmpty(item.options) && item.answer ? 1 : 0
          }
        }
         if (+item.structId === 3) {
          item.options = {}
          item.answer = this.findCapitalJudge(item.answer)
          item.children = []
          if (this.splitPage === 'jf') {
            item.status = item.questionTypeId && item.stem && item.score && item.answer ? 1 : 0
          }
          else if (this.splitPage === 'out' || this.splitPage === 'sm') {
            item.status = item.questionTypeId && item.stem && item.answer ? 1 : 0
          }
        }
        if (+item.structId === 4) {
          item.options = {}
          if (item.answer) {
            item.children = item.answer.split('#@#').map(aitem => {
              return {
                stem: "",
                options: {},
                answer: aitem,
                analysis: ""
              }
            })
            item.answer = ""
          }
          else {
            item.children = [{
              stem: "",
              options: {},
              answer: "",
              analysis: ""
            }]
          }
          let isChildren = item.children && item.children.length > 0
          if (isChildren) {
            item.children.forEach((cItem) => {
              if (!cItem.answer) {
                isChildren = false
              }
            })
          }
          if (this.splitPage === 'jf') {
            item.status = item.questionTypeId && item.stem && item.score && isChildren ? 1 : 0
          }
          else if (this.splitPage === 'out' || this.splitPage === 'sm') {
            item.status = item.questionTypeId && item.stem && isChildren ? 1 : 0
          }
        }
        if ([5, 9, 10].includes(+item.structId)) {
          item.children = []
          item.options = {}
          if (this.splitPage === 'jf') {
            item.status = item.questionTypeId && item.stem && item.score && item.answer ? 1 : 0
          }
          else if (this.splitPage === 'out' || this.splitPage === 'sm') {
            item.status = item.questionTypeId && item.stem && item.answer ? 1 : 0
          }
        }
        if (+item.structId === 7) {
          item.options = {}
          item.answer = ""
          if (!item.children || item.children.length === 0) {
            item.children = [{
              stem: "",
              options: {
                'A': '',
                'B': '',
                'C': '',
                'D': ''
              },
              answer: "",
              analysis: ""
            }]
          }
          else {
            item.children = item.children.map((cItem) => {
              return {
                stem: "",
                structId: cItem.structId ? +cItem.structId : '',
                options: cItem.options ? cItem.options : {
                  'A': '',
                  'B': '',
                  'C': '',
                  'D': ''
                },
                answer: cItem.answer || "",
                analysis: cItem.analysis || "",
              }
            })
          }
          let isChildren = item.children && item.children.length > 0
          if (isChildren) {
            item.children.forEach((cItem) => {
              if (!cItem.answer) {
                isChildren = false
                return;
              }
              if (isEmpty(cItem.options)) {
                isChildren = false
                return;
              }
              if (!isEmpty(cItem.options)) {
                for (let key in cItem.options) {
                  if(!cItem.options[key]) {
                    isChildren = false
                    break;
                  }
                }
              }
              // 分数
              if (!cItem.score && this.splitPage === 'jf') {
                isChildren = false
                return;
              }
            })
          }
          item.status = item.questionTypeId && item.stem && isChildren ? 1 : 0
        }
        if (+item.structId === 8) {
          item.options = {}
          item.answer = ""
          if (!item.children || item.children.length === 0) {
            item.children = [{
              structId: 5,
              questionTypeId: "",
              stem: "",
              options: {},
              answer: "",
              analysis: ""
            }]
          }
          else {
            item.children = item.children.map((cItem) => {
              cItem.structId = cItem.structId ? +cItem.structId : ''
              if (cItem.typeId) {
                cItem.questionTypeId = cItem.typeId
              }
              if (+cItem.structId === 1) {
                  cItem.options = cItem.options ? cItem.options : {}
                  let answer = this.findCapitalLetter(cItem.answer, cItem.options)
                  answer = answer.substring(0, 1)
                  cItem.answer = answer
                }
              if (+cItem.structId === 2 || +cItem.structId === 6) {
                cItem.options = cItem.options ? cItem.options : {}
                cItem.answer = this.findCapitalLetter(cItem.answer, cItem.options)
              }
              if (+cItem.structId === 3) {
                cItem.options = {}
                cItem.answer = this.findCapitalJudge(cItem.answer)
              }
              if (+cItem.structId === 4) {
                cItem.options = {}
                if (cItem.answer) {
                  cItem.children = cItem.answer.split('#@#').map(aitem => {
                    return {
                      stem: "",
                      options: {},
                      answer: aitem,
                      analysis: ""
                    }
                  })
                  cItem.answer = ""
                }
                else {
                  cItem.children = [{
                    stem: "",
                    options: {},
                    answer: "",
                    analysis: ""
                  }]
                }
              }
              return cItem
            })
          }
          let isChildren = item.children && item.children.length > 0
          if (isChildren) {
            item.children.forEach((cItem) => {
              if (!cItem.questionTypeId) {
                isChildren = false
                return;
              }
              if (!cItem.stem) {
                isChildren = false
                return;
              }
              // 答案
              if (+cItem.structId === 4) {
                cItem.children.forEach(aitem => {
                  if (!aitem.answer) {
                    isChildren = false
                    return;
                  }
                })
              }
              else {
                if (!cItem.answer) {
                  isChildren = false
                  return;
                }
              }
              // 选项
              if ([1, 2, 6].includes(+cItem.structId)) {
                if (isEmpty(cItem.options)) {
                  isChildren = false
                  return;
                }
                if (!isEmpty(cItem.options)) {
                  for (let key in cItem.options) {
                    if(!cItem.options[key]) {
                      isChildren = false
                      break;
                    }
                  }
                }
              }
              // 分数
              if (!cItem.score && this.splitPage === 'jf') {
                isChildren = false
                return;
              }
            })
          }
          // 强制组题为0改这里
          item.status = item.questionTypeId && item.stem && isChildren ? 1 : 0
        }
        // 因为要校验难度知识点，都是0
        // item.status = 0
        // 计算题号
        if (![7, 8].includes(+item.structId)) {
          item.orderNumber = index
          item.questionNumber = index++
        }
        else {
          if (!isEmpty(item.children)) {
            item.orderNumber = index
            // 外循环一定要questionNumber
            item.questionNumber = this.splitPage === 'jf' ? '' : index
            item.children = item.children.map(citem => {
              citem.orderNumber = index
              citem.questionNumber = index++
              return citem
            })
          }
          else {
            item.orderNumber = index
            item.questionNumber = index++
          }
        }
        // 处理其他字段
        if (this.splitPage === 'jf') {
          return {
            ...item,
            subjectId: this.subjectId,
          };
        }

        if (this.splitPage === 'out') {
          return {
            ...item,
            subjectId: this.subjectId,
            sameQuestionId: "",
            similarQuestionId: "",
            repeatFlag: "",
            questionTag: {}
          };
        }

        if (this.splitPage === 'sm') {
          return {
            ...item,
            questionTag: {
              stageId: this.stageId,
              subjectId: this.subjectId,
              questionDifficultId: '',
              knowledgePoints: []
            }
          };
        }
      });
      return res
    },
    // 手动划单道题
    doSplitSingle(htmlStr) {
      if (this.splitLoading) {
        return;
      }
      if (this.notEdit) {
        return
      }
      this.splitLoading = true
      const selection = window.getSelection();
      // 如果没有选中任何内容，则不执行任何操作
      if (!selection.rangeCount) {
        this.splitLoading = false
        return;
      }
      this.curRange = selection.getRangeAt(0);
      // 计算上面的题号
      let startNode = this.curRange.startContainer.parentNode
      let start = this.getElementIndex(startNode)
      if (start === -1) {
        this.$message.error("划区异常，请按规范重新划题识别！");
        this.splitLoading = false
        return;
      }
      // console.log(htmlStr);
      this.tagInfo = {
        htmlStr,
        splitApp: this.splitApp,
        curQuestionList: this.questionList,
        insertIndex: start
      }
      this.tagVisible = true;
      this.splitLoading = false
    },
    async setTag(form) {
      if (this.splitLoading) {
        return
      }
      this.splitLoading = true
      let { questionTypeId, start,  splitObj} = form;
      let outputList = await this.dealSplitList(splitObj.outputList, questionTypeId, start)
      if (this.questionList.length === 0) {
        this.questionList = outputList
        this.curQuestionIndex = 0;
        this.curQuestion = this.questionList[0];
      }
      // 插入到中间题块
      else {
        let insertIndex = this.tagInfo.insertIndex
        this.questionList.splice(insertIndex, 0, ...outputList);
        if (this.curQuestionIndex >= insertIndex - 1) {
          let index = this.curQuestionIndex + outputList.length;
          if (this.clickQuestion) {
            this.clickQuestion(index)
          }
          else {
            this.curQuestionIndex = index;
            this.curQuestion = this.questionList[index];
          }
        }
      }

      // 划题
      let htmlStr = splitObj.outputHtml;
      const parser = new DOMParser();
      let doc = parser.parseFromString(htmlStr, "text/html");

      const wrapper = doc.body; // 创建一个新的 div 元素
      this.curRange.extractContents();
      this.curRange.insertNode(wrapper); // 将新的 div 插入原来的选中区域位置

      // // 清除现有的选中状态
      window.getSelection().removeAllRanges();
      this.htmlStr = document.getElementById("splitHtmlEditor").innerHTML;
      this.setLeftQuestionNum()
      setTimeout(() => {
        this.splitLoading = false
      }, 500);
    },
    // 编辑html
    editPaper() {
      this.tempStr = this.htmlStr
      this.editablePaper = true;
      this.$refs.splitHtmlEditor.mountedInit();
    },
    closeEditPaper() {
      this.htmlStr = this.tempStr
      this.tempStr = ""
      this.editablePaper = false;
      // 还原html
      // tinymce.remove();
    },
    saveEditPaper(htmstr) {
      this.tempStr = ""
      this.htmlStr = htmstr
      this.setLeftQuestionNum()
      this.editablePaper = false;
    }
  },
}

export default splitMixins



// WEBPACK FOOTER //
// ./src/pages/htmlSplit/mixins/splitMixins.js